export default __webpack_public_path__ + "static/media/icon-ps4.e39c7737.svg";